var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowUtgl = function SvgShowUtgl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.263 12a6.737 6.737 0 1 1 13.474 0H18a8 8 0 1 0-16 0h1.263ZM10 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#DC9B32"
  })));
};
export default SvgShowUtgl;